function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0 1)"
}, React.createElement("g", {
  transform: "translate(0 2)"
}, React.createElement("rect", {
  fill: "#FCD3D5",
  width: 16,
  height: 10,
  rx: 1
}), React.createElement("rect", {
  fill: "#FFF",
  x: 2,
  y: 2.5,
  width: 4,
  height: 3,
  rx: 0.25
}), React.createElement("path", {
  d: "M4 7a.5.5 0 010 1H2.5a.5.5 0 010-1H4zm3.167 0a.5.5 0 010 1h-1.5a.5.5 0 110-1h1.5zm3.166 0a.5.5 0 110 1h-1.5a.5.5 0 010-1h1.5zM13.5 7a.5.5 0 110 1H12a.5.5 0 110-1h1.5z",
  fill: "#F79DA2"
})), React.createElement("circle", {
  fill: "#EC1C26",
  cx: 14,
  cy: 4,
  r: 4
})), React.createElement("path", {
  d: "M14 6.5a.625.625 0 110 1.25.625.625 0 010-1.25zm0-4c.345 0 .625.28.625.625v2.25a.625.625 0 11-1.25 0v-2.25c0-.345.28-.625.625-.625z",
  fill: "#FFF"
}));

var SvgCreditCardInvalid = function SvgCreditCardInvalid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCreditCardInvalid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CreditCardInvalid.4e98c158.svg";
export { ForwardRef as ReactComponent };